// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TCanUserCreateRequestModel, IMappers, TCanUserCreateRequestResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICanUserCreateRequestResponse } from '../../entities/can_user_create_request/CanUserCreateRequestResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCanUserCreateRequestModel(): TCanUserCreateRequestModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-broker',
    pathApi: '/v1/can-user-create-request/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface ICanUserCreateRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchCanUserCreateRequest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: ICanUserCreateRequestOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCanUserCreateRequestResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCanUserCreateRequestModel(),
    config,
  )) as FetchResponse<TCanUserCreateRequestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICanUserCreateRequestResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCanUserCreateRequestResponse>;
}
